"use client";

import React from "react";
import { Box, Typography } from "@mui/material";

interface FooterProps {
  sidebarOpen: boolean;
}

const Footer: React.FC<FooterProps> = ({ sidebarOpen }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: sidebarOpen ? 240 : 0,
        width: sidebarOpen ? "calc(100% - 240px)" : "100%",
        backgroundColor: "#f5f7fa",
        color: "#133154",
        py: 2,
        px: { xs: 2, sm: 4 },
        textAlign: "center",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
        fontSize: { xs: "0.75rem", sm: "0.875rem" },
        fontWeight: 500,
        zIndex: 1000,
        borderTop: "1px solid #d1d9e0",
        transition: "left 0.3s ease, width 0.3s ease",
      }}
    >
      <Typography variant="body2" sx={{ fontSize: "inherit" }}>
        © {new Date().getFullYear()} <strong>T-Pay Microservice</strong>. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
